export default function HeroSection() {
  return (
    <section className="bg-doctio-beige d-icon-background min-h-[200px] md:min-h-[320px] py-16">
      <div className="py-10 md:py-0 container mx-auto">
        <h1 className="text-left text-d2xl md:text-d4xl font-bold text-doctio-green">
          Vælg dit abonnement
        </h1>

        <div className="space-divider w-2 h-[24px]"></div>
      </div>
    </section>
  );
}
